import module from 'module';

const templateUrl = require('./gl-accounts.template.html');
module.component('glAccounts', {
  templateUrl,
});
